import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-recourse-type-cell-renderer',
  templateUrl: './recourse-type-cell-renderer.html',
  imports: [TranslatePipe],
})
export class RecourseTypeCellRenderer implements ICellRendererAngularComp {
  public params: any;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(params: any): boolean {
    this.params = params;
    return false;
  }
}
